var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidebar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 452.5,
    viewBox: "0 0 10 452.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_139",
    "data-name": "Group 139",
    transform: "translate(-187 -2210)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_30",
    "data-name": "Line 30",
    y2: 446,
    transform: "translate(192 2215.5)",
    fill: "none",
    stroke: "rgba(255,255,255,0.5)",
    strokeLinecap: "round",
    strokeWidth: 2,
    strokeDasharray: "0 5"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_566",
    "data-name": "Ellipse 566",
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(187 2210)",
    fill: "#868686"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebar);
export default __webpack_public_path__ + "static/media/sidebar.9ee59e1bd7100499dabcce6d36814fca.svg";
export { ForwardRef as ReactComponent };